export const checkinModalConversation = {
  guestFallback: "Gast",
  conversationLabel: "Unterhaltung:",
  replyOnWhatsAppLabel: "Auf WhatsApp antworten:",
  replyOnWhatsAppTooltip: "Auf WhatsApp antworten",
};
